(function ($) {
    function retrieve_form_data_array(formData) {
        var formDataArray = [];
        formData.split('&').forEach(function (keyValue) {
            var pair = keyValue.split('=');
            var name = decodeURIComponent(pair[0]);
            var value = decodeURIComponent(pair[1]);

            if (name.includes('topic')) {
                value = $(`select[name="${name}"] option[value="${value}"]`).text();
            }
            if (name.includes('subject')) {
                value = $(`select[name="${name}"] option[value="${value}"]`).text();
            }
            if (name.includes('user_type')) {
                value = $(`select[name="${name}"] option[value="${value}"]`).text();
            }


            if (value && typeof value === 'string') {
                value = value.trim();
            }

            formDataArray.push({
                name: name,
                value: value
            });
        });
        return formDataArray;
    }

    $(document).ready(function () {

        let issueAboutVal = 'none';

        $('select#subject_0, select#subject_1').on('change', function () {
            $('.topics-select').hide();
            $(`.topics-select[data-belongsToSubject="${$(this).find(":selected").val()}"`).show();
        });

        $('.topic-select, .subject-select').each(function () {
            var options = $(this).find('option');
            options.sort(function (a, b) {
                return a.text.localeCompare(b.text);
            });

            $(this).empty().append(options);
        });

        var ajax_url = CIMContactUs.Variables.Ajax.url;

        $('.radio-buttons input[type="radio"]').on('change', function () {
            $('#subject_0').val(false);
            $('#subject_1').val(false);
            let subjectValue = $('input[name="radioGroup"]:checked').val();
            issueAboutVal = subjectValue;
            $('.topics-select').hide();
            $('.subject-field').hide();
            $(`.subject-field.subject_${subjectValue}`).show();
        });


        $('#CAO_CIM_CONTACT_US_FORM').on('submit', function (e) {
            e.preventDefault();

            $('.cao-cim-error').removeClass('cao-cim-error');
            $('#cao_crm_contact_infoboxes').find('.cao-crm-contact-infobox-errors').remove();

            $('#CAO_CIM_CONTACT_US_FORM button[type="submit"]').attr("disabled", true);

            $('#CAO_CIM_CONTACT_US_FORM').addClass('processing');

            var formData = $(this).serialize() + `&issueabout=${issueAboutVal}`;
            var formDataArray = retrieve_form_data_array(formData);

            formDataArray.push({
                name: 'issueabout',
                value: issueAboutVal
            });
            
            formDataArray = JSON.stringify(formDataArray);

            $.ajax({
                type: 'POST',
                url: ajax_url,
                data: {
                    action: 'process_cim_contactus_form',
                    form_data: formData,
                    form_data_array: formDataArray,
                    recaptcha_response: grecaptcha.getResponse()
                },
                success: function (response) {
                    $('#CAO_CIM_CONTACT_US_FORM').removeClass('processing');
                    $('#CAO_CIM_CONTACT_US_FORM button[type="submit"]').attr("disabled", false);
                    if (response.status === 'success') {
                        $('#cao_cim_recaptcha').remove();
                        response.original_form_data.forEach(({ name, value }) => {
                            $(`#${name}`).fadeOut();
                            $('.categories-select').fadeOut();
                            $(`#subject_0 + .select2`).fadeOut();
                            $(`#subject_1 + .select2`).fadeOut();
                            $(`#subject_0`).fadeOut();
                            $(`#subject_1`).fadeOut();
                            $(`#${name} + .select2`).fadeOut();
                            $(`#submitted_${name}`).fadeIn();
                            $(`.submitted_${name}`).fadeIn();
                            $(`#submitted_${name}`).html(value);
                            $(`.submitted_${name}`).html(value);
                        });

                        $('#CAO_CIM_CONTACT_US_FORM .actions').hide();

                        $('#cao_crm_contact_infoboxes').find('.cao-crm-contact-infobox-default').remove();
                        $('#cao_crm_contact_infoboxes').find('.cao-crm-contact-infobox-errors').remove();
                        $('#cao_crm_contact_infoboxes').prepend(`<div class="cao-crm-contact-infobox cao-crm-contact-infobox-confirmation">${response.success_info_box_message}</div>`)
                        $("html, body").animate({ scrollTop: $('#cao_crm_contact_infoboxes').offset().top }, 250);
                    } else if (response.status === 'error') {
                        grecaptcha.reset();
                        if (Object.keys(response.errors).length > 0) {
                            $('#cao_crm_contact_infoboxes').append(`
                            <div class="cao-crm-contact-infobox cao-crm-contact-infobox-errors">
                                <h2>
                                    <span role="presentation" class="fa fa-info-circle"></span>
                                    ${response.error_title}
                                </h2>
                                <ul class="errors" id="cao_crm_contact_errors">
                                </ul>
                            </div>`);

                            Object.keys(response.errors).forEach(function (key) {
                                var value = response.errors[key];
                                
                                if (key === 'topic_0') {
                                    $(`#default_topic`).addClass('cao-cim-error');
                                } else if (key === 'subject') {
                                    $(`#subject_0`).addClass('cao-cim-error');
                                    $(`#subject_1`).addClass('cao-cim-error');
                                } else if (key === 'radioGroup') {
                                    $(`.radio-buttons`).addClass('cao-cim-error');
                                } else {
                                    $(`#${key}`).addClass('cao-cim-error');
                                }
                                $(document).find('#cao_crm_contact_errors').append(`<li class="error">${value}</li>`);
                            });
                            $("html, body").animate({ scrollTop: $('#cao_crm_contact_infoboxes').offset().top }, 250);
                        }
                    }
                },
            });
        });
    });
})(jQuery);